import auth from 'src/router/auth'
import PriceTable from '../PriceTable'
import NewPriceTable from '../NewPriceTable'
import EditPriceTable from '../EditPriceTable'
import CopyPriceTable from '../CopyPriceTable'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: PriceTable,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/price-table',
    name: 'price-table',
    component: PriceTable,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/price-table/new',
    name: 'create-price-table',
    component: NewPriceTable,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/price-table/:id/edit',
    name: 'edit-price-table',
    component: EditPriceTable,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/price-table/:id/copy',
    name: 'copy-price-table',
    component: CopyPriceTable,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/pricetable/routes/index.js